/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gene-by-sample matrix reveals expression patterns at a glance.`)
};

const es_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una matriz de gen por muestra revela patrones de expresión a simple vista.`)
};

const de_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Gen-mal-Probe-Matrix offenbart Expressionsmuster auf einen Blick.`)
};

const nl_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gen-bij-monster-matrix onthult expressiepatronen in één oogopslag.`)
};

const fr_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une matrice gène par échantillon révèle les motifs d'expression en un coup d'œil.`)
};

const it_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una matrice gene-per-campione rivela schemi di espressione a colpo d'occhio.`)
};

const pt_br2_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma matriz gene por amostra revela padrões de expressão rapidamente.`)
};

const pt_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma matriz gene por amostra revela padrões de expressão de relance.`)
};

const ja_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遺伝子×サンプルの行列は、発現パターンを一目で明らかにします。`)
};

const zh_heat_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基因 × 样本矩阵可一眼揭示表达模式。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_ex1", locale)
	if (locale === "en") return en_heat_ex1(inputs)
	if (locale === "es") return es_heat_ex1(inputs)
	if (locale === "de") return de_heat_ex1(inputs)
	if (locale === "nl") return nl_heat_ex1(inputs)
	if (locale === "fr") return fr_heat_ex1(inputs)
	if (locale === "it") return it_heat_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_heat_ex1(inputs)
	if (locale === "pt") return pt_heat_ex1(inputs)
	if (locale === "ja") return ja_heat_ex1(inputs)
	return zh_heat_ex1(inputs)
};